import VC from 'videocontext'
import G from 'gibberish-dsp'

import AST from './AST.js'
import Graph from './Graph.js'

const FlowAV = {
  VideoContext: null,
  AudioContext: null,
  _AST: null,
  _Graph: null,
  setup(canvas) {
    // Keep a reference to these simply
    // for debugging purposes
    this.AudioContext = G
    this.VideoContext = new VC(canvas)
    this._AST = AST
    this._Graph = Graph
  },
  
  start(bg) {
    this.AudioContext.init()
    // VideoContext stops when all clips have finished playing
    // this means we can't add more clips to the timeline (or maybe
    // it does, but I haven't worked out how yet). A black background
    // image plays forever to keep the VC in a constant playing state.
    var bgNode = this.VideoContext.image(bg);
        bgNode.connect(this.VideoContext.destination);
        bgNode.start(0);
    this.VideoContext.play()
  },

  update(code) {
    this._AST.generate(code)
    
    for (let i = 0; i < this._AST.audio.new.length; i++) {
      let o = this._AST.audio.old[i]
      let n = this._AST.audio.new[i]
      let r = (!this._AST.compare(o, n) && (!o || n.arg !== o.arg))
      this._Graph.updateAudio(this.AudioContext, i, n, r)
    }
    
    
    for (let i = 0; i < this._AST.video.new.length; i++) {
      let o = this._AST.video.old[i]
      let n = this._AST.video.new[i]
      // r decides whether we replace a video node or just update it.
      // a node needs updating when its type (Video, Image etc..) or
      // arg change
      let r = (!this._AST.compare(o, n) && (!o || n.arg !== o.arg))
      this._Graph.updateVideo(this.VideoContext, i, n, r)
    }
    for (let i = this._AST.video.new.length; i < this._AST.video.old.length; i++) {
      this._Graph.destroyVideo(i)
    }
    
    this._AST.update()
  }
}

export default FlowAV


// WEBPACK FOOTER //
// ./src/FlowAV.js